module.exports = __webpack_public_path__ + "static/social_expert-71f2e97eaed09ae4a655c77102a8da65.svg";